import { groupService } from '@/services/api/group.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { groupModel } from '@/models/api/group.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const GROUP_MODULE = "api/group";

// ACTIONS
export const GET_ALL_GROUP = 'getAllGroup';
export const CREATE_GROUP = 'createGroup';
export const GET_GROUP = 'getGroup';
export const UPDATE_GROUP = 'updateGroup';
export const UPDATE_GROUP_STATUS = 'updateGroupStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_GROUP_SUCCESS = "allGroupSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_GROUP_SUCCESS = "getGroupSuccess";

export const actions = {
    [GET_ALL_GROUP]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        groupService
            .getAll(filter)
            .then((result) => {
                commit(ALL_GROUP_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_GROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return groupService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_GROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_GROUP]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return groupService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_GROUP_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_GROUP]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return groupService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_GROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_GROUP_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return groupService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_GROUP, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_GROUP_SUCCESS](state, {data}) {
        let group = data.data || [];
        state.list.data = group;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = group.map(item => groupModel(item));
        }
    },
    [GET_GROUP_SUCCESS](state, data) {
        state.details = groupModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
